exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.severity-badge {\n  background-color: #f2f2f2;\n  border-radius: 0.3em;\n  color: #505050;\n  display: inline-block;\n  font-size: 0.9em;\n  font-weight: bold;\n  line-height: 1em;\n  padding: 0.6em 0.4em 0.4em;\n  text-transform: uppercase;\n}\n.severity-badge-critical {\n  background-color: #fae5e1;\n  color: #c0341e;\n}\n.severity-badge-high {\n  background-color: #fff1de;\n  color: #de7e00;\n}\n.severity-badge-medium {\n  background-color: #ede8fb;\n  color: #6d49cb;\n}\n.severity-badge-unknown {\n  background-color: #ffffff;\n  border: 1px solid;\n  color: #707070;\n}\n", ""]);

// exports
